<style lang="scss" scoped>
</style>
<template>
  <div>
    <headerIndex 
      v-on:grid="currentView='grid'"
      v-on:list="currentView='list'"
    ></headerIndex>
    <template v-if="currentView == 'list' && path == '/circuitos'">
      <circuitosList></circuitosList>
    </template>
    <template v-if="currentView == 'grid' && path == '/circuitos'">
      <circuitosGrid></circuitosGrid>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    headerIndex: () => import('@/components/headerIndex/headerIndex.vue'),
    circuitosList: () => import('./List.vue'),
    circuitosGrid: () => import('./Grid.vue')
  },
  data () {
    return {
      currentView: 'list',
      path: ''
    }
  },
  created () {
    this.path = this.$route.path
  }
}
</script>